<template>
  <section class="login">
    <v-developer-header>
      <span slot="title">创造与魔法开发者管理系统</span>
    </v-developer-header>

    <form class="form-content" action="#">
      <dl class="form-controller">
        <dt class="title">账号：</dt>
        <dd class="content">
          <input class="base-input" name="heroUser" type="text" v-model="formDatas.userName" v-validate="'required'" />
          <div class="form-error-tips">
            <span v-show="errors.has('heroUser')"  >{{ errors.first('heroUser') }}</span>
          </div>
        </dd>
        <dd class="right"></dd>
      </dl>

      <dl class="form-controller">
        <dt class="title">密码：</dt>
        <dd class="content">
          <input class="base-input" name="password" type="password" v-model="formDatas.passWord" v-validate="'required'" />
          <div class="form-error-tips">
            <span v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>
        </dd>
        <dd class="right"></dd>
      </dl>

      <dl class="form-controller">
        <dt class="title">常用手机操作系统：</dt>
        <dd class="content">
          <a class="phone-system" :class="{ 'active': formDatas.systemType === '106' }"  href="javascript: void(0)" v-model="formDatas.systemType" @click="appleFn">IOS</a>
          <a class="phone-system" :class="{ 'active': formDatas.systemType === '85' }" href="javascript: void(0)" v-model="formDatas.systemType" @click="androidFn">安卓</a>
        </dd>
        <dd class="right phone-tips-box">
          <a class="often-system" href="javascript: void(0)" @click="tipsFn">什么是常用手机操作系统？</a>
          <div class="phone-tips" v-show="tipsFlag">
            <h3 class="title">常用手机操作系统</h3>
            <p class="desc">
              受限于IOS和安卓不同平台需要分别建立子账号的限制，我们的开发者账户也需要区分IOS和安卓，以便于通过手机端访问开发者管理系统。
              <span class="proposal">建议您根据平时经常用来玩《创造与魔法》游戏的设备类型进行选择。</span>
            </p>
            <i class="icon-arrow-bottom"></i>
          </div>
        </dd>
      </dl>

      <div class="handle">
        <a class="forget-pwd" href="http://i.yingxiong.com/pass/getpassword">忘记密码？</a>
        <a class="new-reg" href="http://i.yingxiong.com/pass/register">新用户注册</a>
      </div>

      <p class="error-tips">{{ formErrot }}</p>

      <div class="sign-in">
        <a class="btn" href="javascript: void(0)" @click="loginFn">登录</a>
      </div>
    </form>

    <!--提示层开始-->
    <!--<v-basic-mask ref="basicMask" :show="maskFlag" @closeMaskEv="closeMaskFn">
      <span slot="desc">请先选择常用手机操作系统</span>
    </v-basic-mask>-->
    <!--提示层结束-->

    <!--加载提示层-->
    <v-loading ref="loading" :show="loading"></v-loading>
  </section>
</template>

<script type="text/ecmascript-6">
  // 头部组件
  import developerHeader from 'components/developerHeader/developerHeader'
  // 引入 cookie插件
  import VueCookie from 'vue-cookie'
  // ajax 请求插件
  import Axios from 'axios'
  // 遮罩层组件
  // import basicMask from 'components/basicMask/basicMask'
  // lading 加载组件
  import loading from 'components/loading/loading'
  // 用户信息相关操作
  import {saveCookie} from 'assets/js/user'
  // 其他错误
  const ERRORS = {
    NET_ERROR: '网络错误',
    UNKNOWN_ERROR: '未知错误'
  }
  export default {
    // 登录页面
    name: 'login',
    data () {
      return {
        // 常用手机操作系统标志
        tipsFlag: false,
        // 加载提示层
        loading: false,
        // 遮罩层开关
        // maskFlag: false,
        // 错误提示
        errorTips: '',
        // 表单错误信息
        formErrot: '',
        // 表单提交信息
        formDatas: {
          // 用户名
          userName: '',
          // 密码
          passWord: '',
          // 系统类型
          systemType: '',
          // 用户id
          userId: VueCookie.get('UserID'),
          // session id
          sessionId: VueCookie.get('SessionID')
        }
      }
    },
    created () {
      /*
      let loginInfo = {
        UserID: VueCookie.get('UserID'),
        SessionID: VueCookie.get('SessionID')
      }
      */
      // 如果已经登录过了，跳转到首页
      if (this.formDatas.userId && this.formDatas.sessionId) {
        // 跳转到个人主页
        this.$router.push({path: '/home'})
      }
    },
    mounted () {
      // axios 前置拦截器
      Axios.interceptors.request.use(config => {
        // 显示 loading 提示层
        this.loading = true
        return config
      })
      // axios 后置拦截器
      Axios.interceptors.response.use(response => {
        // 关闭 loading 提示层
        this.loading = false
        return response
      })
    },
    methods: {
      // 登录
      loginFn () {
        this.$validator.validateAll().then(() => {
          // 表单有错误返回 true 没错误返回 false
          // console.log(this.errors.any())
          // 返回所有错信的信息列表
          // console.log(this.errors.all())
          // 表单是否有错误信息
          let isError = this.errors.any()
          if (isError) {
            // 获取所有错误信息的数组列表
            let formErrors = this.$validator.errors.all()
            // 返回第一个错误信息
            this.formErrot = formErrors[0]
          } else {
            // 是否选择手机系统
            if (this.formDatas.systemType) {
              /* let formData = new FormData()

               for (let key in this.formDatas) {
               formData.append("'" + key + "'", this.formDatas[key])
               //console.log(key + ' = ' + this.formDatas[key])
               } */

              // 实例化表单对象
              let formData = new FormData()
              // 将用户名添加到表单
              formData.append('LoginName', this.formDatas.userName)
              // 将密码添加到表单
              formData.append('PassWord', this.formDatas.passWord)
              // 常用手机操作系统
              formData.append('PlatId', this.formDatas.systemType)
              // 请求登录 api
              Axios.post(`${this.$api.root}/account/New_Login`, formData, {
                // Axios.post(this.$api.root + '/account/New_Login', formData, {
                // 设置请求为表单提交
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }).then((response) => {
                // http 请求成功
                if (response.status === 200) {
                  // 获取接口数据
                  let res = response.data

                  switch (res.Code) {
                    case 0:
                      // 保存登录信息到 cookie
                      saveCookie(res)
                      // 跳转到信息填写页面
                      this.$router.push({name: 'home'})
                      break
                    case 1:
                      // 密码或账号错误
                      // this.errorTips = res.Msg
                      // 将错误信息添加到验证中
                      // this.$validator.errors.add('password', this.errorTips)
                      this.formErrot = res.Msg
                      break
                    case 2:
                      // 错误信息
                      // this.errorTips = res.Msg
                      // 将错误信息添加到验证中
                      // this.$validator.errors.add('password', this.errorTips)
                      this.formErrot = res.Msg
                      break
                    default:
                      // 未知错误
                      // this.$validator.errors.add('password', ERRORS.UNKNOWN_ERROR)
                      this.formErrot = ERRORS.UNKNOWN_ERROR
                  }
                }
              // 请求接口失败
              }).catch((error) => {
                console.log(error)
                // 关闭加载提示层
                this.loading = false
                // this.$validator.errors.add('password', ERRORS.NET_ERROR)
                this.formErrot = ERRORS.NET_ERROR
              })
            // 没有选择手机操作系统
            } else {
              // 打开遮罩层
              // this.maskFlag = true
              this.formErrot = '请选择常用手机操作系统'
            }
          }
        }).catch(() => {
          console.log('表单验证失败')
        })
      },
      androidFn () {
        // 设置安卓系统状态码
        this.formDatas.systemType = '85'
      },
      appleFn () {
        this.formDatas.systemType = '106'
      },
      /*
      closeMaskFn (val) {
        // 设置苹果系统状态码
        this.maskFlag = val
      },
      */
      // 常用操作系统提示信息
      tipsFn () {
        this.tipsFlag = !this.tipsFlag
      }
    },
    components: {
      'v-developer-header': developerHeader,
      // 'v-basic-mask': basicMask,
      'v-loading': loading
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "login.styl";
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue